module.exports = __webpack_public_path__ + "static/img/bg-pic.032c660.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Gotit/bg-pic.png
// module id = 22Y3
// module chunks = 0